const topics = [
  { name: "顶流塌房", heat: "极热", count: 326, icon: "ri-fire-line" },
  { name: "直播翻车", heat: "热", count: 258, icon: "ri-live-line" },
  { name: "选秀黑幕", heat: "热", count: 187, icon: "ri-mic-line" },
  { name: "税务风波", heat: "热", count: 165, icon: "ri-money-cny-box-line" },
  { name: "劈腿实锤", heat: "暖", count: 492, icon: "ri-emotion-sad-line" },
  { name: "虚假代言", heat: "暖", count: 143, icon: "ri-advertisement-line" },
  { name: "综艺剧本", heat: "暖", count: 128, icon: "ri-file-text-line" },
  { name: "MCN 内幕", heat: "暖", count: 97, icon: "ri-building-line" },
  { name: "私生饭爆料", heat: "新", count: 76, icon: "ri-camera-line" },
  { name: "潜规则", heat: "极热", count: 381, icon: "ri-alert-line" },
];

function getHeatStyle(heat: string) {
  switch (heat) {
    case "极热":
      return "bg-primary-500/20 text-primary-400 border-primary-500/30";
    case "热":
      return "bg-accent-500/20 text-accent-400 border-accent-500/30";
    case "暖":
      return "bg-secondary-500/20 text-secondary-400 border-secondary-500/30";
    default:
      return "bg-background-200 text-foreground-500 border-background-300/40";
  }
}

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          热门话题
        </h2>
        <div className="w-16 h-1 bg-accent-500 mx-auto mb-10 rounded-full"></div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 px-5 py-3 rounded-full border cursor-pointer transition-colors hover:scale-105 ${getHeatStyle(topic.heat)}`}
            >
              <i className={`${topic.icon} text-base`}></i>
              <span className="text-sm font-semibold whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}